import { IRootState } from './index';
import { IOffersState, Offer } from './offer.types';

export const selectOffer = ({ offer }: IRootState): IOffersState => offer;

export const selectOfferList = (state: IRootState): Offer[] => selectOffer(state).offersList;

export const createSelectOfferById = (offerId: number) => (state: IRootState): Offer | null =>
  selectOfferList(state).find(item => item.id === offerId) || null;
